import React, { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import EmbeddedNotepadClusterNotesView from './EmbeddedNotepadClusterNotesView';

const formatApiError = (data) => {
  if (!data) return 'Request failed.';
  if (typeof data === 'string') return data;
  if (data.detail) {
    const d = data.detail;
    return Array.isArray(d) ? d.join(' ') : String(d);
  }
  return 'Request failed.';
};

/**
 * Thin module wrapper: wires module-specific cluster link API into EmbeddedNotepadClusterNotesView.
 */
const EmbeddedNotepadClusterNotesTab = ({
  headerDescription,
  fetchClusterLink,
  patchClusterLink,
  containerClassName = 'rounded-2xl bg-white p-4 shadow',
  layoutVariant = 'card',
  fabClassName,
  noteCardViewMode,
  emptyNotesMessage,
}) => {
  const fetchLink = useCallback(async () => fetchClusterLink(), [fetchClusterLink]);

  const patchLink = useCallback(
    async (clusterId) => patchClusterLink(clusterId),
    [patchClusterLink],
  );

  const onLoadError = useCallback((err) => {
    toast.error(
      formatApiError(err.response?.data) || err.message || 'Failed to load cluster link',
    );
  }, []);

  const onLinkError = useCallback((err) => {
    toast.error(
      formatApiError(err.response?.data) || err.message || 'Failed to update cluster link',
    );
  }, []);

  const view = (
    <EmbeddedNotepadClusterNotesView
      headerDescription={headerDescription}
      fetchClusterLink={fetchLink}
      patchClusterLink={patchLink}
      onLoadError={onLoadError}
      onLinkError={onLinkError}
      noteCardViewMode={noteCardViewMode}
      emptyNotesMessage={emptyNotesMessage}
      layoutVariant={layoutVariant}
      fabClassName={fabClassName}
    />
  );

  if (!containerClassName) return view;

  return <div className={containerClassName}>{view}</div>;
};

export default EmbeddedNotepadClusterNotesTab;
